// 全局混合的Vue实例
import { mapGetters, mapActions } from 'vuex'
import system from './system'
import { downloadFile } from '@/util/util'
import { validatenull } from "@/util/validate";

const cnMonthListZH = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
const cnMonthListEN = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.']

export default {
  data() {
    return {
    }
  },
  computed: {
    // 引入所有vuex的state，可以直接通过this来调用，属性名前加上$表示全局属性
    ...mapGetters({
      $userInfo: 'userInfo',
      $pms: 'pms',
      $sidebarCollapse: 'isCollapse'
    }),
    $permissionSet() {
      return new Set(this.$pms[1].map(item => item.operateCode))
    },
    $getMonths() {

    }
  },
  methods: {
    ...system.methods,
    // 展开所有vuex的actions，可以直接通过this来调用，方法名前加上$表示全局方法
    ...mapActions({
    }),
    // 深拷贝
    $clone(obj) {
      return obj ? JSON.parse(JSON.stringify(obj)) : {}
    },
    $isEmpty(list) {
      return !list || !list.length
    },
    $isNotEmpty(list) {
      return !this.$isEmpty(list)
    },
    $paramsToUrl(url, params) {
      if (!params) return url
      let suffix = ''
      for (const key in params) {
        suffix += `&${key}=${params[key]}`
      }
      suffix = url.indexOf('?') > -1 ? suffix : suffix.replace('&', '?')
      return url + suffix
    },
    /**
     * 格式化日期，由于用v-model绑定饿了么框架的日期组件，获取的值不是格式化后的值，因此需要手动格式化
     */
    $parseDate(date) {
      if (typeof date === 'string') {
        if (date.length < 11) return date
        date = new Date(date)
      }
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + month + '-' + day
    },
    /**
     * 按时间排序列表
     * @param list 要被排序的列表，会更改原数组
     * @param timeKey 作为排序依据的时间的key
     * @param ascend 是否升序排列，默认为降序
     */
    $sortByTime(list, timeKey, ascend) {
      list.sort((a, b) => {
        // 默认降序
        const result = this.$day(a[timeKey]).isBefore(b[timeKey]) ? 1 : -1
        return ascend ? -result : result
      })
    },
    $today(pattern = 'YYYY-MM-DD') {
      return this.$day().format(pattern)
    },
    $formatMoment(moment, pattern) {
      if (!moment) return ''
      return this.$day(moment).format(pattern)
    },
    $formatDate(date) {
      return this.$formatMoment(date, 'YYYY-MM-DD')
    },
    $formatDateTime(date) {
      return this.$formatMoment(date, 'YYYY-MM-DD HH:mm:ss')
    },
    /**
     * 返回正确的星期，即0转为7
     * @param day
     */
    $adjustWeekday(day) {
      return day === 0 ? 7 : day
    },
    $getCnMonth(monthNumber, startZero = true) {
      const cnMonthList = localStorage.getItem('lang') == 'en' ? cnMonthListEN : cnMonthListZH;
      return cnMonthList[startZero ? monthNumber : monthNumber - 1]
    },
    $last12Months() {
      return [this.$day().subtract(1, 'y').add(1, 'M').format('YYYY-MM'), this.$day().format('YYYY-MM')]
    },
    $formatMoney(money, symbol = '', fixed = 2, delimiter = ',') {
      if (money === undefined || money === null) return ''
      return this.$accounting.formatMoney(money, symbol, fixed, delimiter)
    },
    $formatInputMoney(money) {
      return this.$formatMoney(money, '', 2, '')
    },
    $showMoney(money) {
      return this.$formatMoney(money) || '0.00'
    },
    $handleCompare(percent) {
      if (!percent) return 'equal'
      // 获取去掉百分号的纯数字
      const number = Number(percent.replace('%', ''))
      return number === 0 ? 'equal' : number > 0 ? 'increase' : 'decrease'
    },
    $arrayToObj(array, key) {
      let obj = {}
      for (let item of array) {
        obj[item[key]] = item
      }
      return obj
    },
    $downloadFile(resp) {
      downloadFile(resp)
    },
    // 处理带字典翻译的表格数据
    $handleTableDict(tableData, dictMap, suffix = 'Text', dictTextKey = 'codeItemName') {
      if (this.$isEmpty(tableData)) return []
      const lang = localStorage.getItem('lang');
      if (lang == 'en') {
        dictTextKey = 'codeItemEnName';
        for(let keys in dictMap) {
          for(let subKeys in dictMap[keys]) {
            const subItem = dictMap[keys][subKeys];
            subItem.codeItemEnName = validatenull(subItem.codeItemEnName) ? subItem.codeItemName : subItem.codeItemEnName;
          }
        }
      }
      tableData.forEach(item => {
        for (let key of Object.keys(item)) {
          // 先按默认字典把“是”和“否”转义
          if (item[key] && typeof item[key] === 'string' && item[key].startsWith('1002')) {
            item[`${key}${suffix}`] = item[key] === '10020001' ? '是' : '否'
          }
          else if (dictMap[key]) {
            item[`${key}${suffix}`] = item[key] && dictMap[key][item[key]] && dictMap[key][item[key]][dictTextKey]
          }
        }
      })
      return tableData
    },
    // 处理带字典翻译的表格数据（字典包含在columns中）
    $handleTableDictInColumns(columns, tableData, options = {dictIdKey: 'codeItemId', dictTextKey: 'codeItemName', dictType: 'array'}) {
      if (this.$isEmpty(tableData)) return [];
      let dictMap = {}
      columns.forEach(item => {
        if (item.dictData) {
          // 先都放入一个大map里
          dictMap[item.originField] = { mapData: {}, originData: item.dictData }
          dictMap[item.originField].mapData = options.dictType === 'array' ? this.$arrayToObj(item.dictData, options.dictIdKey) : item.dictData
          item.field = `${item.originField}Text`
        }
      })
      const lang = localStorage.getItem('lang');
      if (lang == 'en') {
        options.dictTextKey = 'codeItemEnName';
        for(let keys in dictMap) {
          for(let subKeys in dictMap[keys]) {
            const subItem = dictMap[keys][subKeys];
            subItem.codeItemEnName = validatenull(subItem.codeItemEnName) ? subItem.codeItemName : subItem.codeItemEnName;
          }
        }
      }
      tableData.forEach(row => {
        for (let field in row) {
          if (row[field] && dictMap[field] && dictMap[field].mapData[row[field]]) {
            row[`${field}Text`] = dictMap[field].mapData[row[field]][options.dictTextKey]
          }
        }
      })
      return dictMap
    }
  }
}
